"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const algorithm_1 = require("../algorithm");
const covariate_1 = require("../../data-field/covariate/covariate");
const lodash_1 = require("lodash");
const json_covariate_1 = require("../../../parsers/json/json-covariate");
const data_field_1 = require("../../data-field/data-field");
const datum_1 = require("../../data/datum");
const json_derived_field_1 = require("../../../parsers/json/json-derived-field");
class RegressionAlgorithm extends algorithm_1.Algorithm {
    constructor(regressionAlgorithmJson) {
        super(regressionAlgorithmJson);
        this.getAllFields = lodash_1.memoize(() => {
            return data_field_1.DataField.getUniqueDataFields(lodash_1.flatten(this.covariates.map(currentCovariate => {
                return currentCovariate
                    .getDescendantFields()
                    .concat(currentCovariate);
            })).concat(this.additionalFields));
        });
        this.covariates = regressionAlgorithmJson.covariates
            .map(covariateJson => {
            return json_covariate_1.parseCovariateJsonToCovariate(covariateJson, regressionAlgorithmJson.covariates, regressionAlgorithmJson.derivedFields);
        })
            .sort((a, b) => a.name.localeCompare(b.name));
        /* Do this otherwise the getAllFields method will an array which will
        have an undefined in it due to this being undefined */
        this.additionalFields = [];
        /* Names of all algorithm fields which are involved in calculating
        the algorithm output i.e. all fields but the additionl fields*/
        const algorithmFieldNames = this.getAllFields().map((field) => {
            return field.name;
        });
        this.additionalFields = regressionAlgorithmJson.derivedFields.filter((derivedFieldJson) => {
            return algorithmFieldNames.indexOf(derivedFieldJson.name) === -1;
        }).map((additionalFieldJson) => {
            return json_derived_field_1.parseDerivedFieldJsonToDerivedField(additionalFieldJson, regressionAlgorithmJson.derivedFields, regressionAlgorithmJson.covariates);
        });
        /* Clear the cache for the getAllFields method since the call made above
        did not have the additional fields in it */
        this.getAllFields.cache.clear();
    }
    calculateScore(data) {
        /* Go through all the covariates and calculate the data needed to
        calculate the coefficient for each one. On each loop we add the data
        returned to the currentData variable so that we don't recalculate data
        */
        const componentCalculationData = this.covariates.reduce((currentData, covariate) => {
            const dataForCurrentCovariate = covariate.calculateDataToCalculateCoefficent(currentData, this.userFunctions, this.tables);
            return currentData.concat(dataForCurrentCovariate);
        }, this.validateData(data));
        return this.covariates
            .map(covariate => covariate.getComponent(componentCalculationData, this.userFunctions, this.tables))
            .reduce(lodash_1.add, 0);
    }
    getCovariatesForGroup(group) {
        return this.covariates.filter(covariate => {
            return covariate.isPartOfGroup(group);
        });
    }
    getCovariatesWithoutGroup(group) {
        return this.covariates.filter(covariate => {
            return covariate.isPartOfGroup(group) === false;
        });
    }
    getAllFieldsForGroup(group) {
        const covariatesForGroup = this.getCovariatesForGroup(group);
        return data_field_1.DataField.getUniqueDataFields(lodash_1.flatten(covariatesForGroup.map(currentCovariate => {
            return currentCovariate.getDescendantFields();
        }))).concat(covariatesForGroup);
    }
    replaceCovariate(externalCovariate) {
        const currentCovariate = this.covariates.find(covariate => {
            return covariate.name === externalCovariate.name;
        });
        if (!currentCovariate) {
            console.warn(`No covariate with name ${externalCovariate.name} found to replace`);
            return this;
        }
        const newCovariate = Object.setPrototypeOf(Object.assign({}, currentCovariate, {
            name: externalCovariate.name,
            beta: externalCovariate.beta,
        }), covariate_1.Covariate.prototype);
        return Object.setPrototypeOf(Object.assign({}, this, {
            covariates: this.covariates
                .filter(covariate => {
                return covariate.name !== externalCovariate.name;
            })
                .concat(newCovariate),
        }), Object.getPrototypeOf(this));
    }
    /**
     * Goes through each datum in the data arg and does the following checks:
     * 1. Checks whether they are within the bounds defined by the interval
     * field on the corresponding DataField object. If they aren't, sets them
     * to either the lower or upper bound
     *
     * @private
     * @param {Data} data
     * @returns {Data}
     * @memberof RegressionAlgorithm
     */
    validateData(data) {
        const allDataFields = this.getAllFields();
        return data.map(datum => {
            const dataFieldForCurrentDatum = data_field_1.DataField.findDataFieldWithName(allDataFields, datum.name);
            return dataFieldForCurrentDatum
                ? datum_1.datumFactoryFromDataField(dataFieldForCurrentDatum, datum.coefficent)
                : datum;
        });
    }
}
exports.RegressionAlgorithm = RegressionAlgorithm;
//# sourceMappingURL=regression-algorithm.js.map